var bind = function (fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};
var $ = jQuery;

/* --------------------------------------------
  Initialization
  @Params: jQuery element
  @Returns: none
*/
var LinkedField = function ($element) {
  this.change = bind(this.change, this);
  this.element = $element;

  $element.on("change", this.change);

  this.change(null, "true");
};

/* --------------------------------------------
  Complete
  @Params: data
  @Returns: none
*/
LinkedField.prototype.change = function (e, reset) {
  var linkTo = $("." + this.element.attr("data-link-to")),
    label = this.element.val(),
    optgroup = linkTo.find("optgroup");

  // Only clear the value on the autocomplete and the initialization
  if (reset != "true" && e.originalEvent !== undefined) {
    linkTo.val("");
  }

  optgroup
    .show()
    .not('[id="' + label + '"]')
    .hide();
};

module.exports = LinkedField;
